import { Grid, Button, Breadcrumbs, Paper, FormControlLabel, RadioGroup, Radio } from "@material-ui/core";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import { traerEstadosComunicacion, setEstadoSolicitudComunicacionActual } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas";
import { useEffect } from "react";
import { ListadoSolicitudesComunicacion } from "./ListadoSolicitudesComunicacion";
import { AREAS_USUARIOS } from "../../utils/constants";
export const ComunicacionConEmpresasHome = () => {
    const dispatch = useDispatch();
    const [menu, setMenu] = useState(0);
    const { areas: areasUsuario } = useSelector((state) => state.auth);
    const { estadoComunicacionActual } = useSelector((state) => state.comunicacionEmpresas);
    const tieneAreaAfiliaciones = areasUsuario.find((area) => area.idArea === AREAS_USUARIOS.NACIONAL);

    useEffect(() => {
        dispatch(traerEstadosComunicacion());
    }, [dispatch]);

    const ESTADOS_AFILIACIONES = [
        { estado: tieneAreaAfiliaciones ? 'Afiliaciones' : 'Mesa de Ayuda', id: 1 },
        { estado: tieneAreaAfiliaciones ? 'Mesa de Ayuda' : 'Afiliaciones', id: 2 },
        { estado: 'Caso Cerrado', id: 3 },
    ]

    return (
        <div>
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center">
                <Grid item xs={12} styles={{ padding: 5 }}>
                    <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
                        <Button color={"inherit"}
                            onClick={() => { setMenu(1) }}>
                            <PlaylistAddCheckIcon />
                            Solicitudes
                        </Button>

                    </Breadcrumbs>
                </Grid>
                <Grid item xs={12}>
                    {menu === 1 && (
                        <>
                            <Paper style={{ padding: "1rem", margin: '0.5rem' }}>
                                <RadioGroup
                                    row
                                    style={{ justifyContent: "space-around" }}
                                    value={estadoComunicacionActual}
                                    onChange={(e) => { dispatch(setEstadoSolicitudComunicacionActual(e.target.value)) }}>

                                    {ESTADOS_AFILIACIONES?.map((estadoComunicacion) => {
                                        return (
                                            <FormControlLabel
                                                key={estadoComunicacion.id.toString()}
                                                label={estadoComunicacion.estado}
                                                value={estadoComunicacion.id.toString()}
                                                control={<Radio />}
                                                style={{ marginLeft: "0.5rem" }}
                                            />);

                                    })}
                                </RadioGroup>
                            </Paper>
                            <ListadoSolicitudesComunicacion />
                        </>
                    )}
                </Grid>
            </Grid>
        </div>
    );
};